import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { clientsService } from "@/api/services";
import type {
    Client,
    ClientActivite,
    ClientAdresse,
    ClientContact,
    ClientNote,
} from "@/types/domain";

export default function ClientDetailPage() {
    const { clientId } = useParams<{ clientId: string }>();

    const [client, setClient] = useState<Client | null>(null);
    const [contacts, setContacts] = useState<ClientContact[]>([]);
    const [adresses, setAdresses] = useState<ClientAdresse[]>([]);
    const [activites, setActivites] = useState<ClientActivite[]>([]);
    const [notes, setNotes] = useState<ClientNote[]>([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [editingClient, setEditingClient] = useState(false);

    const [editNomLegal, setEditNomLegal] = useState("");
    const [editNomCommercial, setEditNomCommercial] = useState("");
    const [editTypeClient, setEditTypeClient] = useState("");
    const [editStatut, setEditStatut] = useState("");
    const [editCourrielGeneral, setEditCourrielGeneral] = useState("");
    const [editTelephoneGeneral, setEditTelephoneGeneral] = useState("");
    const [editLangue, setEditLangue] = useState("");
    const [editDevise, setEditDevise] = useState("");

    const [editSubmitting, setEditSubmitting] = useState(false);
    const [editError, setEditError] = useState<string | null>(null);
    const [showContactForm, setShowContactForm] = useState(false);

    const [contactPrenom, setContactPrenom] = useState("");
    const [contactNom, setContactNom] = useState("");
    const [contactTitrePoste, setContactTitrePoste] = useState("");
    const [contactDepartement, setContactDepartement] = useState("");
    const [contactCourriel, setContactCourriel] = useState("");
    const [contactTelephone, setContactTelephone] = useState("");
    const [contactPosteTelephonique, setContactPosteTelephonique] = useState("");
    const [contactCellulaire, setContactCellulaire] = useState("");

    const [contactPrincipal, setContactPrincipal] = useState(false);
    const [contactFacturation, setContactFacturation] = useState(false);
    const [contactAchats, setContactAchats] = useState(false);
    const [contactExpedition, setContactExpedition] = useState(false);
    const [contactActif, setContactActif] = useState(true);

    const [contactNotes, setContactNotes] = useState("");

    const [contactSubmitting, setContactSubmitting] = useState(false);
    const [contactError, setContactError] = useState<string | null>(null);
    const [editingContactId, setEditingContactId] = useState<string | null>(null);

    const [editContactPrenom, setEditContactPrenom] = useState("");
    const [editContactNom, setEditContactNom] = useState("");
    const [editContactTitrePoste, setEditContactTitrePoste] = useState("");
    const [editContactDepartement, setEditContactDepartement] = useState("");
    const [editContactCourriel, setEditContactCourriel] = useState("");
    const [editContactTelephone, setEditContactTelephone] = useState("");
    const [editContactPosteTelephonique, setEditContactPosteTelephonique] = useState("");
    const [editContactCellulaire, setEditContactCellulaire] = useState("");

    const [editContactPrincipal, setEditContactPrincipal] = useState(false);
    const [editContactFacturation, setEditContactFacturation] = useState(false);
    const [editContactAchats, setEditContactAchats] = useState(false);
    const [editContactExpedition, setEditContactExpedition] = useState(false);
    const [editContactActif, setEditContactActif] = useState(true);

    const [editContactNotes, setEditContactNotes] = useState("");

    const [editContactSubmitting, setEditContactSubmitting] = useState(false);
    const [editContactError, setEditContactError] = useState<string | null>(null);
    const [showAdresseForm, setShowAdresseForm] = useState(false);

    const [editingAdresseId, setEditingAdresseId] = useState<string | null>(null);
    const [editAdresseType, setEditAdresseType] = useState("expedition");
    const [editAdresseNom, setEditAdresseNom] = useState("");
    const [editAdresseLigne1, setEditAdresseLigne1] = useState("");
    const [editAdresseLigne2, setEditAdresseLigne2] = useState("");
    const [editAdresseVille, setEditAdresseVille] = useState("");
    const [editAdresseProvinceEtat, setEditAdresseProvinceEtat] = useState("");
    const [editAdresseCodePostal, setEditAdresseCodePostal] = useState("");
    const [editAdressePays, setEditAdressePays] = useState("Canada");
    const [editAdressePrincipale, setEditAdressePrincipale] = useState(false);
    const [editAdresseActive, setEditAdresseActive] = useState(true);
    const [editAdresseInstructionsLivraison, setEditAdresseInstructionsLivraison] = useState("");
    const [editAdresseSubmitting, setEditAdresseSubmitting] = useState(false);
    const [editAdresseError, setEditAdresseError] = useState<string | null>(null);

    const [adresseType, setAdresseType] = useState("expedition");
    const [adresseNom, setAdresseNom] = useState("");
    const [adresseLigne1, setAdresseLigne1] = useState("");
    const [adresseLigne2, setAdresseLigne2] = useState("");
    const [adresseVille, setAdresseVille] = useState("");
    const [adresseProvinceEtat, setAdresseProvinceEtat] = useState("");
    const [adresseCodePostal, setAdresseCodePostal] = useState("");
    const [adressePays, setAdressePays] = useState("Canada");
    const [adressePrincipale, setAdressePrincipale] = useState(false);
    const [adresseActive, setAdresseActive] = useState(true);
    const [adresseInstructionsLivraison, setAdresseInstructionsLivraison] = useState("");

    const [adresseSubmitting, setAdresseSubmitting] = useState(false);
    const [adresseError, setAdresseError] = useState<string | null>(null);

    const [noteTitre, setNoteTitre] = useState("");
    const [noteContenu, setNoteContenu] = useState("");
    const [noteType, setNoteType] = useState("generale");
    const [noteConfidentielle, setNoteConfidentielle] = useState(false);
    const [noteSubmitting, setNoteSubmitting] = useState(false);
    const [noteError, setNoteError] = useState<string | null>(null);
    const [activiteContactId, setActiviteContactId] = useState("");
    const [activiteType, setActiviteType] = useState("suivi");
    const [activiteSujet, setActiviteSujet] = useState("");
    const [activiteDescription, setActiviteDescription] = useState("");
    const [activiteDateEcheance, setActiviteDateEcheance] = useState("");
    const [activiteStatut, setActiviteStatut] = useState("planifiee");
    const [activiteSubmitting, setActiviteSubmitting] = useState(false);
    const [activiteError, setActiviteError] = useState<string | null>(null);

    useEffect(() => {
        if (!clientId) {
            setError("Identifiant client manquant.");
            setLoading(false);
            return;
        }

        const loadClient = async () => {
            try {
                setLoading(true);
                setError(null);

                const [
                    clientData,
                    contactsData,
                    adressesData,
                    activitesData,
                    notesData,
                ] = await Promise.all([
                    clientsService.detail(clientId),
                    clientsService.contacts(clientId),
                    clientsService.adresses(clientId),
                    clientsService.activites(clientId),
                    clientsService.notes(clientId),
                ]);

                setClient(clientData as Client);
                setContacts(contactsData);
                setAdresses(adressesData);
                setActivites(activitesData);
                setNotes(notesData);
            } catch (err) {
                console.error("Erreur chargement fiche client :", err);
                setError("Impossible de charger la fiche client.");
            } finally {
                setLoading(false);
            }
        };

        loadClient();
    }, [clientId]);

    const handleCreateNote = async () => {
        if (!clientId || !noteTitre.trim() || !noteContenu.trim()) {
            return;
        }

        try {
            setNoteSubmitting(true);
            setNoteError(null);

            await clientsService.createNote(clientId, {
                titre: noteTitre.trim(),
                contenu: noteContenu.trim(),
                type_note: noteType,
                confidentielle: noteConfidentielle,
            });

            const notesData = await clientsService.notes(clientId);
            setNotes(notesData);

            setNoteTitre("");
            setNoteContenu("");
            setNoteType("generale");
            setNoteConfidentielle(false);
        } catch (err) {
            console.error("Erreur création note :", err);
            setNoteError("Impossible d'ajouter la note.");
        } finally {
            setNoteSubmitting(false);
        }
    };

    const handleCreateActivite = async () => {
        if (!clientId || !activiteSujet.trim()) {
            return;
        }

        try {
            setActiviteSubmitting(true);
            setActiviteError(null);

            await clientsService.createActivite(clientId, {
                contact_id: activiteContactId || null,
                type_activite: activiteType,
                sujet: activiteSujet.trim(),
                description: activiteDescription.trim(),
                date_echeance: activiteDateEcheance || null,
                statut: activiteStatut,
                responsable_id: null,
            });

            const activitesData = await clientsService.activites(clientId);
            setActivites(activitesData);

            setActiviteContactId("");
            setActiviteType("suivi");
            setActiviteSujet("");
            setActiviteDescription("");
            setActiviteDateEcheance("");
            setActiviteStatut("planifiee");
        } catch (err) {
            console.error("Erreur création activité :", err);
            setActiviteError("Impossible d'ajouter l'activité.");
        } finally {
            setActiviteSubmitting(false);
        }
    };
    const startEditingClient = () => {
        if (!client) {
            return;
        }

        setEditNomLegal(client.nom_legal || "");
        setEditNomCommercial(client.nom_commercial || "");
        setEditTypeClient(client.type_client || "client");
        setEditStatut(client.statut || "actif");
        setEditCourrielGeneral(client.courriel_general || "");
        setEditTelephoneGeneral(client.telephone_general || "");
        setEditLangue(client.langue || "fr-CA");
        setEditDevise(client.devise || "CAD");
        setEditError(null);
        setEditingClient(true);
    };

    const handleUpdateClient = async () => {
        if (!clientId || !client || !editNomLegal.trim()) {
            return;
        }

        try {
            setEditSubmitting(true);
            setEditError(null);

            await clientsService.update(clientId, {
                nom_legal: editNomLegal.trim(),
                nom_commercial: editNomCommercial.trim(),
                type_client: editTypeClient,
                statut: editStatut,
                courriel_general: editCourrielGeneral.trim(),
                telephone_general: editTelephoneGeneral.trim(),
                langue: editLangue,
                devise: editDevise,
            });

            const clientData = await clientsService.detail(clientId);
            setClient(clientData as Client);

            setEditingClient(false);
        } catch (err) {
            console.error("Erreur modification client :", err);
            setEditError("Impossible de modifier le client.");
        } finally {
            setEditSubmitting(false);
        }
    };
    const handleCreateContact = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!clientId || !contactPrenom.trim() || !contactNom.trim()) {
            setContactError("Le prénom et le nom sont obligatoires.");
            return;
        }

        try {
            setContactSubmitting(true);
            setContactError(null);

            await clientsService.createContact(clientId, {
                client_id: clientId,
                prenom: contactPrenom.trim(),
                nom: contactNom.trim(),
                titre_poste: contactTitrePoste.trim(),
                departement: contactDepartement.trim(),
                courriel: contactCourriel.trim(),
                telephone: contactTelephone.trim(),
                poste_telephonique: contactPosteTelephonique.trim(),
                cellulaire: contactCellulaire.trim(),
                contact_principal: contactPrincipal,
                contact_facturation: contactFacturation,
                contact_achats: contactAchats,
                contact_expedition: contactExpedition,
                actif: contactActif,
                notes: contactNotes.trim(),
            });

            const contactsData = await clientsService.contacts(clientId);
            setContacts(contactsData);

            setContactPrenom("");
            setContactNom("");
            setContactTitrePoste("");
            setContactDepartement("");
            setContactCourriel("");
            setContactTelephone("");
            setContactPosteTelephonique("");
            setContactCellulaire("");
            setContactPrincipal(false);
            setContactFacturation(false);
            setContactAchats(false);
            setContactExpedition(false);
            setContactActif(true);
            setContactNotes("");

            setShowContactForm(false);
        } catch (err) {
            console.error("Erreur création contact :", err);
            setContactError("Impossible de créer le contact.");
        } finally {
            setContactSubmitting(false);
        }
    };

    const startEditingContact = (contact: ClientContact) => {
        setEditingContactId(contact.id);

        setEditContactPrenom(contact.prenom || "");
        setEditContactNom(contact.nom || "");
        setEditContactTitrePoste(contact.titre_poste || "");
        setEditContactDepartement(contact.departement || "");
        setEditContactCourriel(contact.courriel || "");
        setEditContactTelephone(contact.telephone || "");
        setEditContactPosteTelephonique(contact.poste_telephonique || "");
        setEditContactCellulaire(contact.cellulaire || "");

        setEditContactPrincipal(contact.contact_principal);
        setEditContactFacturation(contact.contact_facturation);
        setEditContactAchats(contact.contact_achats);
        setEditContactExpedition(contact.contact_expedition);
        setEditContactActif(contact.actif);

        setEditContactNotes(contact.notes || "");
        setEditContactError(null);
    };

    const handleUpdateContact = async () => {
        if (!clientId || !editingContactId) {
            return;
        }

        try {
            setEditContactSubmitting(true);
            setEditContactError(null);

            await clientsService.updateContact(
                clientId,
                editingContactId,
                {
                    prenom: editContactPrenom.trim(),
                    nom: editContactNom.trim(),
                    titre_poste: editContactTitrePoste.trim(),
                    departement: editContactDepartement.trim(),
                    courriel: editContactCourriel.trim(),
                    telephone: editContactTelephone.trim(),
                    poste_telephonique: editContactPosteTelephonique.trim(),
                    cellulaire: editContactCellulaire.trim(),
                    contact_principal: editContactPrincipal,
                    contact_facturation: editContactFacturation,
                    contact_achats: editContactAchats,
                    contact_expedition: editContactExpedition,
                    actif: editContactActif,
                    notes: editContactNotes.trim(),
                }
            );

            const contactsData = await clientsService.contacts(clientId);
            setContacts(contactsData);

            setEditingContactId(null);
        } catch (err) {
            console.error("Erreur modification contact :", err);
            setEditContactError("Impossible de modifier le contact.");
        } finally {
            setEditContactSubmitting(false);
        }
    };

    const startEditingAdresse = (adresse: ClientAdresse) => {
        setEditingAdresseId(adresse.id);
        setShowAdresseForm(false);

        setEditAdresseType(adresse.type_adresse || "expedition");
        setEditAdresseNom(adresse.nom_adresse || "");
        setEditAdresseLigne1(adresse.adresse_ligne_1 || "");
        setEditAdresseLigne2(adresse.adresse_ligne_2 || "");
        setEditAdresseVille(adresse.ville || "");
        setEditAdresseProvinceEtat(adresse.province_etat || "");
        setEditAdresseCodePostal(adresse.code_postal || "");
        setEditAdressePays(adresse.pays || "Canada");
        setEditAdressePrincipale(adresse.principale);
        setEditAdresseActive(adresse.active);
        setEditAdresseInstructionsLivraison(adresse.instructions_livraison || "");
        setEditAdresseError(null);
    };

    const handleUpdateAdresse = async () => {
        if (!clientId || !editingAdresseId) {
            return;
        }

        try {
            setEditAdresseSubmitting(true);
            setEditAdresseError(null);

            await clientsService.updateAdresse(clientId, editingAdresseId, {
                type_adresse: editAdresseType,
                nom_adresse: editAdresseNom.trim(),
                adresse_ligne_1: editAdresseLigne1.trim(),
                adresse_ligne_2: editAdresseLigne2.trim(),
                ville: editAdresseVille.trim(),
                province_etat: editAdresseProvinceEtat.trim(),
                code_postal: editAdresseCodePostal.trim(),
                pays: editAdressePays.trim(),
                principale: editAdressePrincipale,
                active: editAdresseActive,
                instructions_livraison: editAdresseInstructionsLivraison.trim(),
            });

            const adressesData = await clientsService.adresses(clientId);
            setAdresses(adressesData);

            setEditingAdresseId(null);
        } catch (err) {
            console.error("Erreur modification adresse :", err);
            setEditAdresseError("Impossible de modifier l'adresse.");
        } finally {
            setEditAdresseSubmitting(false);
        }
    };

    const handleCreateAdresse = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (
            !clientId ||
            !adresseLigne1.trim() ||
            !adresseVille.trim() ||
            !adresseCodePostal.trim()
        ) {
            setAdresseError(
                "L'adresse, la ville et le code postal sont obligatoires."
            );
            return;
        }

        try {
            setAdresseSubmitting(true);
            setAdresseError(null);

            await clientsService.createAdresse(clientId, {
                type_adresse: adresseType,
                nom_adresse: adresseNom.trim(),
                adresse_ligne_1: adresseLigne1.trim(),
                adresse_ligne_2: adresseLigne2.trim(),
                ville: adresseVille.trim(),
                province_etat: adresseProvinceEtat.trim(),
                code_postal: adresseCodePostal.trim(),
                pays: adressePays.trim(),
                principale: adressePrincipale,
                active: adresseActive,
                instructions_livraison: adresseInstructionsLivraison.trim(),
            });

            const adressesData = await clientsService.adresses(clientId);
            setAdresses(adressesData);

            setAdresseType("expedition");
            setAdresseNom("");
            setAdresseLigne1("");
            setAdresseLigne2("");
            setAdresseVille("");
            setAdresseProvinceEtat("");
            setAdresseCodePostal("");
            setAdressePays("Canada");
            setAdressePrincipale(false);
            setAdresseActive(true);
            setAdresseInstructionsLivraison("");

            setShowAdresseForm(false);
        } catch (err) {
            console.error("Erreur création adresse :", err);
            setAdresseError("Impossible de créer l'adresse.");
        } finally {
            setAdresseSubmitting(false);
        }
    };

    if (loading) {
        return <div className="p-6">Chargement de la fiche client...</div>;
    }

    if (error || !client) {
        return <div className="p-6">{error ?? "Client introuvable."}</div>;
    }

    return (
        <div className="space-y-6 p-6">
            <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                    <h1 className="text-2xl font-semibold">
                        {client.nom_commercial || client.nom_legal}
                    </h1>

                    <p className="text-sm text-muted-foreground">
                        {client.code_client} · {client.nom_legal}
                    </p>
                </div>

                <button
                    type="button"
                    onClick={startEditingClient}
                    className="rounded-md border border-border px-4 py-2 text-sm font-medium hover:bg-muted"
                >
                    Modifier le client
                </button>
            </div>

            {editingClient && (
                <section className="space-y-4 rounded-lg border border-border bg-card p-5">
                    <div>
                        <h2 className="text-lg font-semibold">Modifier le client</h2>
                        <p className="text-sm text-muted-foreground">
                            Mettre à jour les informations générales du client.
                        </p>
                    </div>

                    {editError && (
                        <p className="text-sm text-red-600">{editError}</p>
                    )}

                    <div className="grid gap-4 md:grid-cols-2">
                        <label className="space-y-1">
                            <span className="text-sm font-medium">Nom légal</span>
                            <input
                                value={editNomLegal}
                                onChange={(e) => setEditNomLegal(e.target.value)}
                                className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                            />
                        </label>

                        <label className="space-y-1">
                            <span className="text-sm font-medium">Nom commercial</span>
                            <input
                                value={editNomCommercial}
                                onChange={(e) => setEditNomCommercial(e.target.value)}
                                className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                            />
                        </label>

                        <label className="space-y-1">
                            <span className="text-sm font-medium">Type</span>
                            <select
                                value={editTypeClient}
                                onChange={(e) => setEditTypeClient(e.target.value)}
                                className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                            >
                                <option value="client">Client</option>
                                <option value="prospect">Prospect</option>
                            </select>
                        </label>

                        <label className="space-y-1">
                            <span className="text-sm font-medium">Statut</span>
                            <select
                                value={editStatut}
                                onChange={(e) => setEditStatut(e.target.value)}
                                className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                            >
                                <option value="actif">Actif</option>
                                <option value="inactif">Inactif</option>
                            </select>
                        </label>

                        <label className="space-y-1">
                            <span className="text-sm font-medium">Courriel général</span>
                            <input
                                type="email"
                                value={editCourrielGeneral}
                                onChange={(e) => setEditCourrielGeneral(e.target.value)}
                                className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                            />
                        </label>

                        <label className="space-y-1">
                            <span className="text-sm font-medium">Téléphone général</span>
                            <input
                                value={editTelephoneGeneral}
                                onChange={(e) => setEditTelephoneGeneral(e.target.value)}
                                className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                            />
                        </label>

                        <label className="space-y-1">
                            <span className="text-sm font-medium">Langue</span>
                            <select
                                value={editLangue}
                                onChange={(e) => setEditLangue(e.target.value)}
                                className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                            >
                                <option value="fr-CA">Français (Canada)</option>
                                <option value="en-CA">English (Canada)</option>
                            </select>
                        </label>

                        <label className="space-y-1">
                            <span className="text-sm font-medium">Devise</span>
                            <select
                                value={editDevise}
                                onChange={(e) => setEditDevise(e.target.value)}
                                className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                            >
                                <option value="CAD">CAD</option>
                                <option value="USD">USD</option>
                            </select>
                        </label>
                    </div>

                    <div className="flex justify-end gap-2">
                        <button
                            type="button"
                            onClick={() => {
                                setEditError(null);
                                setEditingClient(false);
                            }}
                            className="rounded-md border border-border px-4 py-2 text-sm font-medium"
                        >
                            Annuler
                        </button>

                        <button
                            type="button"
                            onClick={handleUpdateClient}
                            disabled={editSubmitting}
                            className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground disabled:opacity-50"
                        >
                            {editSubmitting ? "Enregistrement..." : "Enregistrer"}
                        </button>
                    </div>
                </section>
            )}

            <div className="grid gap-4 md:grid-cols-2">
                <div className="rounded-lg border border-border p-4">
                    <p className="text-xs text-muted-foreground">Courriel</p>
                    <p className="mt-1">{client.courriel_general || "—"}</p>
                </div>

                <div className="rounded-lg border border-border p-4">
                    <p className="text-xs text-muted-foreground">Téléphone</p>
                    <p className="mt-1">{client.telephone_general || "—"}</p>
                </div>

                <div className="rounded-lg border border-border p-4">
                    <p className="text-xs text-muted-foreground">Type</p>
                    <p className="mt-1">{client.type_client}</p>
                </div>

                <div className="rounded-lg border border-border p-4">
                    <p className="text-xs text-muted-foreground">Statut</p>
                    <p className="mt-1">{client.statut}</p>
                </div>
            </div>

            <section className="space-y-3">
                <div className="flex flex-wrap items-start justify-between gap-3">
                    <div>
                        <h2 className="text-lg font-semibold">Contacts</h2>
                        <p className="text-sm text-muted-foreground">
                            Contacts associés à ce client
                        </p>
                    </div>

                    <button
                        type="button"
                        onClick={() => {
                            setContactError(null);
                            setShowContactForm((current) => !current);
                        }}
                        className="rounded-md border border-border px-4 py-2 text-sm font-medium hover:bg-muted"
                    >
                        {showContactForm ? "Annuler" : "+ Ajouter un contact"}
                    </button>
                </div>

                {showContactForm && (
                    <form
                        onSubmit={handleCreateContact}
                        className="space-y-4 rounded-lg border border-border bg-card p-5"
                    >
                        <div>
                            <h3 className="text-lg font-semibold">Ajouter un contact</h3>
                            <p className="text-sm text-muted-foreground">
                                Ajouter une personne-ressource associée à ce client.
                            </p>
                        </div>

                        {contactError && (
                            <p className="text-sm text-red-600">
                                {contactError}
                            </p>
                        )}

                        <div className="grid gap-4 md:grid-cols-2">
                            <label className="space-y-1">
                                <span className="text-sm font-medium">Prénom *</span>
                                <input
                                    value={contactPrenom}
                                    onChange={(e) => setContactPrenom(e.target.value)}
                                    required
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>

                            <label className="space-y-1">
                                <span className="text-sm font-medium">Nom *</span>
                                <input
                                    value={contactNom}
                                    onChange={(e) => setContactNom(e.target.value)}
                                    required
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>

                            <label className="space-y-1">
                                <span className="text-sm font-medium">Titre de poste</span>
                                <input
                                    value={contactTitrePoste}
                                    onChange={(e) => setContactTitrePoste(e.target.value)}
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>

                            <label className="space-y-1">
                                <span className="text-sm font-medium">Département</span>
                                <input
                                    value={contactDepartement}
                                    onChange={(e) => setContactDepartement(e.target.value)}
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>

                            <label className="space-y-1">
                                <span className="text-sm font-medium">Courriel</span>
                                <input
                                    type="email"
                                    value={contactCourriel}
                                    onChange={(e) => setContactCourriel(e.target.value)}
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>

                            <label className="space-y-1">
                                <span className="text-sm font-medium">Téléphone</span>
                                <input
                                    value={contactTelephone}
                                    onChange={(e) => setContactTelephone(e.target.value)}
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>

                            <label className="space-y-1">
                                <span className="text-sm font-medium">Poste téléphonique</span>
                                <input
                                    value={contactPosteTelephonique}
                                    onChange={(e) => setContactPosteTelephonique(e.target.value)}
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>

                            <label className="space-y-1">
                                <span className="text-sm font-medium">Cellulaire</span>
                                <input
                                    value={contactCellulaire}
                                    onChange={(e) => setContactCellulaire(e.target.value)}
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>
                        </div>

                        <div className="grid gap-3 md:grid-cols-2">
                            <label className="flex items-center gap-2 text-sm">
                                <input
                                    type="checkbox"
                                    checked={contactPrincipal}
                                    onChange={(e) => setContactPrincipal(e.target.checked)}
                                />
                                Contact principal
                            </label>

                            <label className="flex items-center gap-2 text-sm">
                                <input
                                    type="checkbox"
                                    checked={contactFacturation}
                                    onChange={(e) => setContactFacturation(e.target.checked)}
                                />
                                Facturation
                            </label>

                            <label className="flex items-center gap-2 text-sm">
                                <input
                                    type="checkbox"
                                    checked={contactAchats}
                                    onChange={(e) => setContactAchats(e.target.checked)}
                                />
                                Achats
                            </label>

                            <label className="flex items-center gap-2 text-sm">
                                <input
                                    type="checkbox"
                                    checked={contactExpedition}
                                    onChange={(e) => setContactExpedition(e.target.checked)}
                                />
                                Expédition
                            </label>

                            <label className="flex items-center gap-2 text-sm">
                                <input
                                    type="checkbox"
                                    checked={contactActif}
                                    onChange={(e) => setContactActif(e.target.checked)}
                                />
                                Actif
                            </label>
                        </div>

                        <label className="block space-y-1">
                            <span className="text-sm font-medium">Notes</span>
                            <textarea
                                value={contactNotes}
                                onChange={(e) => setContactNotes(e.target.value)}
                                rows={3}
                                className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                            />
                        </label>

                        <div className="flex justify-end gap-2">
                            <button
                                type="button"
                                onClick={() => {
                                    setContactError(null);
                                    setShowContactForm(false);
                                }}
                                className="rounded-md border border-border px-4 py-2 text-sm font-medium"
                            >
                                Annuler
                            </button>

                            <button
                                type="submit"
                                disabled={
                                    contactSubmitting ||
                                    !contactPrenom.trim() ||
                                    !contactNom.trim()
                                }
                                className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground disabled:opacity-50"
                            >
                                {contactSubmitting ? "Ajout..." : "Ajouter le contact"}
                            </button>
                        </div>
                    </form>
                )}
                {contacts.length === 0 ? (
                    <p className="text-sm text-muted-foreground">
                        Aucun contact.
                    </p>
                ) : (
                    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                        {contacts.map((contact) => (
                            <div
                                key={contact.id}
                                className="rounded-lg border border-border p-4"
                            >
                                <div className="flex items-start justify-between gap-3">
                                    <div className="font-medium">
                                        {contact.prenom} {contact.nom}
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => startEditingContact(contact)}
                                        className="rounded-md border border-border px-2 py-1 text-xs font-medium hover:bg-muted"
                                    >
                                        Modifier
                                    </button>
                                </div>

                                <div className="mt-1 text-sm text-muted-foreground">
                                    {contact.titre_poste || "—"}
                                </div>
                                {contact.departement && (
                                    <div className="text-xs text-muted-foreground">
                                        {contact.departement}
                                    </div>
                                )}

                                <div className="mt-3 space-y-1 text-sm">
                                    <div>{contact.courriel || "—"}</div>

                                    <div>
                                        {contact.telephone || "—"}
                                        {contact.poste_telephonique
                                            ? ` poste ${contact.poste_telephonique}`
                                            : ""}
                                    </div>

                                    {contact.cellulaire && (
                                        <div>Cellulaire : {contact.cellulaire}</div>
                                    )}
                                </div>
                                <div className="mt-3 flex flex-wrap gap-2 text-xs">
                                    {contact.contact_principal && (
                                        <span className="rounded-full border border-border px-2 py-1">
                                            Principal
                                        </span>
                                    )}

                                    {contact.contact_facturation && (
                                        <span className="rounded-full border border-border px-2 py-1">
                                            Facturation
                                        </span>
                                    )}

                                    {contact.contact_achats && (
                                        <span className="rounded-full border border-border px-2 py-1">
                                            Achats
                                        </span>
                                    )}

                                    {contact.contact_expedition && (
                                        <span className="rounded-full border border-border px-2 py-1">
                                            Expédition
                                        </span>
                                    )}
                                </div>
                                {editingContactId === contact.id && (
                                    <div className="mt-4 space-y-4 rounded-md border border-border bg-muted/20 p-4">
                                        <div>
                                            <div className="font-medium">
                                                Modifier {contact.prenom} {contact.nom}
                                            </div>
                                            <p className="text-sm text-muted-foreground">
                                                Mettre à jour les informations de ce contact.
                                            </p>
                                        </div>

                                        {editContactError && (
                                            <p className="text-sm text-red-600">
                                                {editContactError}
                                            </p>
                                        )}

                                        <div className="grid gap-4 md:grid-cols-2">
                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Prénom</span>
                                                <input
                                                    value={editContactPrenom}
                                                    onChange={(e) => setEditContactPrenom(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>

                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Nom</span>
                                                <input
                                                    value={editContactNom}
                                                    onChange={(e) => setEditContactNom(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>

                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Titre de poste</span>
                                                <input
                                                    value={editContactTitrePoste}
                                                    onChange={(e) => setEditContactTitrePoste(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>

                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Département</span>
                                                <input
                                                    value={editContactDepartement}
                                                    onChange={(e) => setEditContactDepartement(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>

                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Courriel</span>
                                                <input
                                                    type="email"
                                                    value={editContactCourriel}
                                                    onChange={(e) => setEditContactCourriel(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>

                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Téléphone</span>
                                                <input
                                                    value={editContactTelephone}
                                                    onChange={(e) => setEditContactTelephone(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>

                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Poste téléphonique</span>
                                                <input
                                                    value={editContactPosteTelephonique}
                                                    onChange={(e) => setEditContactPosteTelephonique(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>

                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Cellulaire</span>
                                                <input
                                                    value={editContactCellulaire}
                                                    onChange={(e) => setEditContactCellulaire(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>
                                        </div>

                                        <div className="grid gap-3 md:grid-cols-2">
                                            <label className="flex items-center gap-2 text-sm">
                                                <input
                                                    type="checkbox"
                                                    checked={editContactPrincipal}
                                                    onChange={(e) => setEditContactPrincipal(e.target.checked)}
                                                />
                                                Contact principal
                                            </label>

                                            <label className="flex items-center gap-2 text-sm">
                                                <input
                                                    type="checkbox"
                                                    checked={editContactFacturation}
                                                    onChange={(e) => setEditContactFacturation(e.target.checked)}
                                                />
                                                Facturation
                                            </label>

                                            <label className="flex items-center gap-2 text-sm">
                                                <input
                                                    type="checkbox"
                                                    checked={editContactAchats}
                                                    onChange={(e) => setEditContactAchats(e.target.checked)}
                                                />
                                                Achats
                                            </label>

                                            <label className="flex items-center gap-2 text-sm">
                                                <input
                                                    type="checkbox"
                                                    checked={editContactExpedition}
                                                    onChange={(e) => setEditContactExpedition(e.target.checked)}
                                                />
                                                Expédition
                                            </label>

                                            <label className="flex items-center gap-2 text-sm">
                                                <input
                                                    type="checkbox"
                                                    checked={editContactActif}
                                                    onChange={(e) => setEditContactActif(e.target.checked)}
                                                />
                                                Actif
                                            </label>
                                        </div>

                                        <label className="block space-y-1">
                                            <span className="text-sm font-medium">Notes</span>
                                            <textarea
                                                value={editContactNotes}
                                                onChange={(e) => setEditContactNotes(e.target.value)}
                                                rows={3}
                                                className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                            />
                                        </label>

                                        <div className="flex justify-end gap-2">
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setEditContactError(null);
                                                    setEditingContactId(null);
                                                }}
                                                className="rounded-md border border-border px-4 py-2 text-sm font-medium"
                                            >
                                                Annuler
                                            </button>

                                            <button
                                                type="button"
                                                onClick={handleUpdateContact}
                                                disabled={editContactSubmitting}
                                                className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground disabled:opacity-50"
                                            >
                                                {editContactSubmitting ? "Enregistrement..." : "Enregistrer"}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </section>

            <section className="space-y-3">
                <div className="flex flex-wrap items-start justify-between gap-3">
                    <div>
                        <h2 className="text-lg font-semibold">Adresses</h2>
                        <p className="text-sm text-muted-foreground">
                            Adresses de facturation, expédition et sites
                        </p>
                    </div>

                    <button
                        type="button"
                        onClick={() => {
                            setAdresseError(null);
                            setShowAdresseForm((current) => !current);
                        }}
                        className="rounded-md border border-border px-4 py-2 text-sm font-medium hover:bg-muted"
                    >
                        {showAdresseForm ? "Annuler" : "+ Ajouter une adresse"}
                    </button>
                </div>

                {showAdresseForm && (
                    <form
                        onSubmit={handleCreateAdresse}
                        className="space-y-4 rounded-lg border border-border bg-card p-5"
                    >
                        <div>
                            <h3 className="text-lg font-semibold">Ajouter une adresse</h3>
                            <p className="text-sm text-muted-foreground">
                                Ajouter une adresse associée à ce client.
                            </p>
                        </div>

                        {adresseError && (
                            <p className="text-sm text-red-600">
                                {adresseError}
                            </p>
                        )}

                        <div className="grid gap-4 md:grid-cols-2">
                            <label className="space-y-1">
                                <span className="text-sm font-medium">Type d'adresse</span>
                                <select
                                    value={adresseType}
                                    onChange={(e) => setAdresseType(e.target.value)}
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                >
                                    <option value="expedition">Expédition</option>
                                    <option value="facturation">Facturation</option>
                                    <option value="site">Site</option>
                                    <option value="autre">Autre</option>
                                </select>
                            </label>

                            <label className="space-y-1">
                                <span className="text-sm font-medium">Nom du site / emplacement</span>
                                <input
                                    value={adresseNom}
                                    onChange={(e) => setAdresseNom(e.target.value)}
                                    placeholder="Ex. Entrepôt principal, Bureau, Mine, Chantier"
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>

                            <label className="space-y-1 md:col-span-2">
                                <span className="text-sm font-medium">Adresse *</span>
                                <input
                                    value={adresseLigne1}
                                    onChange={(e) => setAdresseLigne1(e.target.value)}
                                    required
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>

                            <label className="space-y-1 md:col-span-2">
                                <span className="text-sm font-medium">
                                    Adresse ligne 2
                                </span>
                                <input
                                    value={adresseLigne2}
                                    onChange={(e) => setAdresseLigne2(e.target.value)}
                                    placeholder="Suite, unité, local..."
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>

                            <label className="space-y-1">
                                <span className="text-sm font-medium">Ville *</span>
                                <input
                                    value={adresseVille}
                                    onChange={(e) => setAdresseVille(e.target.value)}
                                    required
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>

                            <label className="space-y-1">
                                <span className="text-sm font-medium">
                                    Province / État
                                </span>
                                <input
                                    value={adresseProvinceEtat}
                                    onChange={(e) => setAdresseProvinceEtat(e.target.value)}
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>

                            <label className="space-y-1">
                                <span className="text-sm font-medium">Code postal *</span>
                                <input
                                    value={adresseCodePostal}
                                    onChange={(e) => setAdresseCodePostal(e.target.value)}
                                    required
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>

                            <label className="space-y-1">
                                <span className="text-sm font-medium">Pays</span>
                                <input
                                    value={adressePays}
                                    onChange={(e) => setAdressePays(e.target.value)}
                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                />
                            </label>
                        </div>

                        <div className="flex flex-wrap gap-6">
                            <label className="flex items-center gap-2 text-sm">
                                <input
                                    type="checkbox"
                                    checked={adressePrincipale}
                                    onChange={(e) => setAdressePrincipale(e.target.checked)}
                                />
                                Adresse principale
                            </label>

                            <label className="flex items-center gap-2 text-sm">
                                <input
                                    type="checkbox"
                                    checked={adresseActive}
                                    onChange={(e) => setAdresseActive(e.target.checked)}
                                />
                                Active
                            </label>
                        </div>

                        <label className="block space-y-1">
                            <span className="text-sm font-medium">
                                Instructions de livraison
                            </span>
                            <textarea
                                value={adresseInstructionsLivraison}
                                onChange={(e) =>
                                    setAdresseInstructionsLivraison(e.target.value)
                                }
                                rows={3}
                                placeholder="Ex. Livraison porte arrière..."
                                className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                            />
                        </label>

                        <div className="flex justify-end gap-2">
                            <button
                                type="button"
                                onClick={() => {
                                    setAdresseError(null);
                                    setShowAdresseForm(false);
                                }}
                                className="rounded-md border border-border px-4 py-2 text-sm font-medium"
                            >
                                Annuler
                            </button>

                            <button
                                type="submit"
                                disabled={
                                    adresseSubmitting ||
                                    !adresseLigne1.trim() ||
                                    !adresseVille.trim() ||
                                    !adresseCodePostal.trim()
                                }
                                className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground disabled:opacity-50"
                            >
                                {adresseSubmitting ? "Ajout..." : "Ajouter l'adresse"}
                            </button>
                        </div>
                    </form>
                )}

                {adresses.length === 0 ? (
                    <p className="text-sm text-muted-foreground">
                        Aucune adresse.
                    </p>
                ) : (
                    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                        {adresses.map((adresse) => (
                            <div
                                key={adresse.id}
                                className="rounded-lg border border-border p-4"
                            >
                                <div className="flex items-start justify-between gap-3">
                                    <div className="font-medium">
                                        {adresse.nom_adresse}
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => startEditingAdresse(adresse)}
                                        className="rounded-md border border-border px-2 py-1 text-xs font-medium hover:bg-muted"
                                    >
                                        Modifier
                                    </button>
                                </div>

                                <div className="mt-1 text-xs uppercase text-muted-foreground">
                                    {adresse.type_adresse}
                                </div>
                                {adresse.principale && (
                                    <div className="mt-2">
                                        <span className="rounded-full border border-border px-2 py-1 text-xs">
                                            Adresse principale
                                        </span>
                                    </div>
                                )}

                                <div className="mt-3 space-y-1 text-sm">
                                    <div>{adresse.adresse_ligne_1}</div>

                                    {adresse.adresse_ligne_2 && (
                                        <div>{adresse.adresse_ligne_2}</div>
                                    )}

                                    <div>
                                        {adresse.ville}, {adresse.province_etat}{" "}
                                        {adresse.code_postal}
                                    </div>

                                    <div>{adresse.pays}</div>
                                    {adresse.instructions_livraison && (
                                        <div className="mt-3 rounded-md bg-muted/50 p-3 text-sm">
                                            <div className="text-xs font-medium uppercase text-muted-foreground">
                                                Instructions de livraison
                                            </div>

                                            <div className="mt-1">
                                                {adresse.instructions_livraison}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {editingAdresseId === adresse.id && (
                                    <div className="mt-4 space-y-4 rounded-md border border-border bg-muted/20 p-4">
                                        <div>
                                            <div className="font-medium">
                                                Modifier l'adresse
                                            </div>
                                            <p className="text-sm text-muted-foreground">
                                                Mettre à jour les informations de cette adresse.
                                            </p>
                                        </div>

                                        {editAdresseError && (
                                            <p className="text-sm text-red-600">
                                                {editAdresseError}
                                            </p>
                                        )}

                                        <div className="grid gap-4 md:grid-cols-2">
                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Type d'adresse</span>
                                                <select
                                                    value={editAdresseType}
                                                    onChange={(e) => setEditAdresseType(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                >
                                                    <option value="expedition">Expédition</option>
                                                    <option value="facturation">Facturation</option>
                                                    <option value="site">Site</option>
                                                    <option value="autre">Autre</option>
                                                </select>
                                            </label>

                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Nom du site / emplacement</span>
                                                <input
                                                    value={editAdresseNom}
                                                    onChange={(e) => setEditAdresseNom(e.target.value)}
                                                    placeholder="Ex. Entrepôt principal, Bureau, Mine, Chantier"
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>

                                            <label className="space-y-1 md:col-span-2">
                                                <span className="text-sm font-medium">Adresse</span>
                                                <input
                                                    value={editAdresseLigne1}
                                                    onChange={(e) => setEditAdresseLigne1(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>

                                            <label className="space-y-1 md:col-span-2">
                                                <span className="text-sm font-medium">Adresse ligne 2</span>
                                                <input
                                                    value={editAdresseLigne2}
                                                    onChange={(e) => setEditAdresseLigne2(e.target.value)}
                                                    placeholder="Suite, unité, local..."
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>

                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Ville</span>
                                                <input
                                                    value={editAdresseVille}
                                                    onChange={(e) => setEditAdresseVille(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>

                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Province / État</span>
                                                <input
                                                    value={editAdresseProvinceEtat}
                                                    onChange={(e) => setEditAdresseProvinceEtat(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>

                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Code postal</span>
                                                <input
                                                    value={editAdresseCodePostal}
                                                    onChange={(e) => setEditAdresseCodePostal(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>

                                            <label className="space-y-1">
                                                <span className="text-sm font-medium">Pays</span>
                                                <input
                                                    value={editAdressePays}
                                                    onChange={(e) => setEditAdressePays(e.target.value)}
                                                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                                />
                                            </label>
                                        </div>

                                        <div className="flex flex-wrap gap-6">
                                            <label className="flex items-center gap-2 text-sm">
                                                <input
                                                    type="checkbox"
                                                    checked={editAdressePrincipale}
                                                    onChange={(e) => setEditAdressePrincipale(e.target.checked)}
                                                />
                                                Adresse principale
                                            </label>

                                            <label className="flex items-center gap-2 text-sm">
                                                <input
                                                    type="checkbox"
                                                    checked={editAdresseActive}
                                                    onChange={(e) => setEditAdresseActive(e.target.checked)}
                                                />
                                                Active
                                            </label>
                                        </div>

                                        <label className="block space-y-1">
                                            <span className="text-sm font-medium">Instructions de livraison</span>
                                            <textarea
                                                value={editAdresseInstructionsLivraison}
                                                onChange={(e) =>
                                                    setEditAdresseInstructionsLivraison(e.target.value)
                                                }
                                                rows={3}
                                                placeholder="Ex. Livraison porte arrière..."
                                                className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                                            />
                                        </label>

                                        <div className="flex justify-end gap-2">
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setEditAdresseError(null);
                                                    setEditingAdresseId(null);
                                                }}
                                                className="rounded-md border border-border px-4 py-2 text-sm font-medium"
                                            >
                                                Annuler
                                            </button>

                                            <button
                                                type="button"
                                                onClick={handleUpdateAdresse}
                                                disabled={editAdresseSubmitting}
                                                className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground disabled:opacity-50"
                                            >
                                                {editAdresseSubmitting ? "Enregistrement..." : "Enregistrer"}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </section>

            <section className="space-y-3">
                <div>
                    <h2 className="text-lg font-semibold">Ajouter une activité</h2>
                    <p className="text-sm text-muted-foreground">
                        Ajouter un suivi, un appel ou un courriel à la fiche client
                    </p>
                </div>

                <div className="grid gap-3">
                    <input
                        type="text"
                        value={activiteSujet}
                        onChange={(e) => setActiviteSujet(e.target.value)}
                        placeholder="Sujet de l'activité"
                        className="rounded-md border border-border bg-background px-3 py-2 text-sm"
                    />

                    <textarea
                        value={activiteDescription}
                        onChange={(e) => setActiviteDescription(e.target.value)}
                        placeholder="Description"
                        rows={4}
                        className="rounded-md border border-border bg-background px-3 py-2 text-sm"
                    />

                    <div className="flex flex-wrap gap-3">
                        <select
                            value={activiteType}
                            onChange={(e) => setActiviteType(e.target.value)}
                            className="rounded-md border border-border bg-background px-3 py-2 text-sm"
                        >
                            <option value="suivi">Suivi</option>
                            <option value="appel">Appel</option>
                            <option value="courriel">Courriel</option>
                        </select>

                        <select
                            value={activiteStatut}
                            onChange={(e) => setActiviteStatut(e.target.value)}
                            className="rounded-md border border-border bg-background px-3 py-2 text-sm"
                        >
                            <option value="planifiee">Planifiée</option>
                            <option value="completee">Complétée</option>
                        </select>

                        <select
                            value={activiteContactId}
                            onChange={(e) => setActiviteContactId(e.target.value)}
                            className="rounded-md border border-border bg-background px-3 py-2 text-sm"
                        >
                            <option value="">Aucun contact</option>
                            {contacts.map((contact) => (
                                <option key={contact.id} value={contact.id}>
                                    {contact.prenom} {contact.nom}
                                </option>
                            ))}
                        </select>

                        <input
                            type="date"
                            value={activiteDateEcheance}
                            onChange={(e) => setActiviteDateEcheance(e.target.value)}
                            className="rounded-md border border-border bg-background px-3 py-2 text-sm"
                        />
                    </div>

                    <div>
                        <button
                            type="button"
                            onClick={handleCreateActivite}
                            disabled={activiteSubmitting || !activiteSujet.trim()}
                            className="rounded-md border border-border px-4 py-2 text-sm font-medium disabled:opacity-50"
                        >
                            {activiteSubmitting ? "Ajout..." : "Ajouter l'activité"}
                        </button>
                    </div>

                    {activiteError && (
                        <p className="text-sm text-red-600">
                            {activiteError}
                        </p>
                    )}
                </div>
            </section>

            <section className="space-y-3">
                <div>
                    <h2 className="text-lg font-semibold">Activités</h2>
                    <p className="text-sm text-muted-foreground">
                        Historique des interactions et suivis avec le client
                    </p>
                </div>

                {activites.length === 0 ? (
                    <p className="text-sm text-muted-foreground">
                        Aucune activité.
                    </p>
                ) : (
                    <div className="space-y-3">
                        {activites.map((activite) => (
                            <div
                                key={activite.id}
                                className="rounded-lg border border-border p-4"
                            >
                                <div className="flex flex-wrap items-start justify-between gap-2">
                                    <div>
                                        <div className="font-medium">{activite.sujet}</div>
                                        <div className="mt-1 text-xs uppercase text-muted-foreground">
                                            {activite.type_activite}
                                        </div>
                                    </div>

                                    <span className="rounded-full border border-border px-2 py-1 text-xs">
                                        {activite.statut}
                                    </span>
                                </div>

                                {activite.description && (
                                    <p className="mt-3 text-sm">
                                        {activite.description}
                                    </p>
                                )}

                                <div className="mt-3 text-xs text-muted-foreground">
                                    {new Date(activite.date_activite).toLocaleDateString("fr-CA")}
                                </div>

                                {activite.date_echeance && (
                                    <div className="mt-1 text-xs text-muted-foreground">
                                        Échéance :{" "}
                                        {new Date(activite.date_echeance).toLocaleDateString("fr-CA")}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </section>

            <section className="space-y-3">
                <div>
                    <h2 className="text-lg font-semibold">Ajouter une note</h2>
                    <p className="text-sm text-muted-foreground">
                        Ajouter une note interne à la fiche client
                    </p>
                </div>

                <div className="grid gap-3">
                    <input
                        type="text"
                        value={noteTitre}
                        onChange={(e) => setNoteTitre(e.target.value)}
                        placeholder="Titre de la note"
                        className="rounded-md border border-border bg-background px-3 py-2 text-sm"
                    />

                    <textarea
                        value={noteContenu}
                        onChange={(e) => setNoteContenu(e.target.value)}
                        placeholder="Contenu de la note"
                        rows={4}
                        className="rounded-md border border-border bg-background px-3 py-2 text-sm"
                    />

                    <div className="flex flex-wrap items-center gap-3">
                        <select
                            value={noteType}
                            onChange={(e) => setNoteType(e.target.value)}
                            className="rounded-md border border-border bg-background px-3 py-2 text-sm"
                        >
                            <option value="generale">Générale</option>
                            <option value="commerciale">Commerciale</option>
                            <option value="service">Service</option>
                            <option value="technique">Technique</option>
                        </select>

                        <label className="flex items-center gap-2 text-sm">
                            <input
                                type="checkbox"
                                checked={noteConfidentielle}
                                onChange={(e) => setNoteConfidentielle(e.target.checked)}
                            />
                            Confidentielle
                        </label>

                        <button
                            type="button"
                            onClick={handleCreateNote}
                            disabled={
                                noteSubmitting ||
                                !noteTitre.trim() ||
                                !noteContenu.trim()
                            }
                            className="rounded-md border border-border px-4 py-2 text-sm font-medium disabled:opacity-50"
                        >
                            {noteSubmitting ? "Ajout..." : "Ajouter la note"}
                        </button>
                    </div>

                    {noteError && (
                        <p className="text-sm text-red-600">
                            {noteError}
                        </p>
                    )}
                </div>
            </section>

            <section className="space-y-3">
                <div>
                    <h2 className="text-lg font-semibold">Notes internes</h2>
                    <p className="text-sm text-muted-foreground">
                        Informations internes liées au client
                    </p>
                </div>

                {notes.length === 0 ? (
                    <p className="text-sm text-muted-foreground">
                        Aucune note.
                    </p>
                ) : (
                    <div className="grid gap-4 md:grid-cols-2">
                        {notes.map((note) => (
                            <div
                                key={note.id}
                                className="rounded-lg border border-border p-4"
                            >
                                <div className="flex flex-wrap items-start justify-between gap-2">
                                    <div className="font-medium">{note.titre}</div>

                                    <span className="rounded-full border border-border px-2 py-1 text-xs">
                                        {note.type_note}
                                    </span>
                                </div>

                                <p className="mt-3 text-sm">
                                    {note.contenu}
                                </p>

                                <div className="mt-3 text-xs text-muted-foreground">
                                    {new Date(note.cree_le).toLocaleDateString("fr-CA")}
                                </div>

                                {note.confidentielle && (
                                    <div className="mt-2 text-xs font-medium">
                                        Confidentielle
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </section>

        </div>
    );
}
